"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeadServiceLineWaiverResponse = void 0;
var LeadServiceLineWaiverResponse;
(function (LeadServiceLineWaiverResponse) {
    LeadServiceLineWaiverResponse[LeadServiceLineWaiverResponse["Consented"] = 0] = "Consented";
    LeadServiceLineWaiverResponse[LeadServiceLineWaiverResponse["Waived"] = 1] = "Waived";
})(LeadServiceLineWaiverResponse = exports.LeadServiceLineWaiverResponse || (exports.LeadServiceLineWaiverResponse = {}));
//# sourceMappingURL=LeadServiceLineWaiverResponse.js.map